import * as React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
//import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const PDFViewer = ({ url }: any): JSX.Element => {
    const [width, setWidth] = React.useState(0);
    const [numPages, setNumPages] = React.useState(null);
    
    const handleWidthChange = () => {
        let element = document.querySelector(".docSecPage");
        if(element)
        {
            //alert(element.clientWidth);
            setWidth(element?.clientWidth || 0);
        }
    }
    React.useLayoutEffect(() => {
        handleWidthChange();
        window.addEventListener("resize", handleWidthChange);
        return () => {
            window.removeEventListener("resize", handleWidthChange);
        };
    }, [numPages]);
    // React.useEffect(() => {
    //     pdfjs.getDocument(url).promise.then((pdf: any) => {
    //         setNumPages(pdf.numPages);
    //     });
    // }, [url]);
    const onDocumentLoadSuccess = ({ numPages }: any) => {
        setNumPages(numPages);
    };
    
    return (
        <React.Fragment>
            <div className={"docSecDocument"}>
                <Document
                    file={url}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                    <React.Fragment key={`page_${index + 1}`}>
                        {(index > 0) && (<div className={"docSecPageDivider"}></div>)}
                        <div className={"docSecPage"}>
                            <Page
                                pageNumber={index + 1}
                                width={width}
                            />
                        </div>
                    </React.Fragment>
                    ))}
                </Document>
            </div>
        </React.Fragment>
    );
}

export default PDFViewer;